import React, { useEffect, useState } from 'react';
import Loadable from '../../../components/loadable/Loadable';
import styles from './ImportDataGridView.styles';
import MultiSelectDropdownWLabel from '../../../components/dropdown/multiselectdropdownwlabel/MultiSelectDropdownWLabel';
import { BUTTON_TYPE } from '../../../components/button/constants';
import { useDispatch, useSelector } from 'react-redux';
import { componentKey, setClickedRecipientData, setEditPayerData, setFileOnlyForStateFlag, setGridRecordsSelected, setGridViewPayerList, setIsFinalFormSubmittedSuccessfully, setPayerUpdationSuccessful, setRecipientEditSuccessfull, setReloadFormGridPageFieldsData, setReloadGridRecords, setSaveImportFormSuccessData, setSubmittedRecordsHasErrors, setgridViewBoxSelected, updateImportGridRecords, updatePaginationState } from './ImportDataGridViewSlice';
import { componentKey as authenticationComponentKey } from '../../authentication/AuthenticationSlice';
import CheckboxWLabel from '../../../components/checkbox/checkboxwlabel/CheckboxWLabel';
import TxTooltipWIcon from '../../../components/tooltip/txtooltipwicon/TxTooltipWIcon';
import SelectDropdown from '../../../components/dropdown/selectdropdown/SelectDropdown';
import { addNotifications } from '../../toaster/ToasterPortalSlice';
import { TOASTER_VARIANT } from '../../../components/toast/constants';
import Label from '../../../components/label/Label';
import { VEC_ICON_NAME } from '../../../components/icons/constants';
import Icons from '../../../components/icons/Icons';
import RichGrid from '../../../components/richgrid/RichGrid';
import RadioInput from '../../../components/input/radioinput/RadioInput';
import IconLabel from '../../../components/iconlabel/IconLabel';
import { ROW_SELECTION_OPTIONS } from '../../../components/richgrid/constants';
import Forms from '../../../../libs/utility/formsutility/Forms';
import { applyBoxToSelectedRecords, deleteSingleRecord, finalSubmitSelectedRecords, getFormGridPageFieldsData, getFormGridRecords, getRecipientDataForEdit, gridViewDownloadReports, proceedWithoutUpdatingTin, setSelectedPayerList, submitEditedPayer, submitEditedRecipient, updateSingleBox } from './ImportDataGridViewSaga';
import { FORM_IDS, FORM_NAMES } from '../../constants/constants';
import { IMPORT_DATA_LOADING_STATES, IMPORT_DATA_STATES_MESSAGE_MAP } from './constants';
import General from '../../../../libs/utility/General';
import Popup from '../../../components/popup/Popup';
import ConfirmationPopup from '../../../components/popup/confirmationpopup/ConfirmationPopup';
import { FORM_SECTION_ROUTES } from '../../formssection/constants';
import useGarbageCollector from '../../../../libs/garbagecollector/garbageCollectorHooks';
import TextInput from '../../../components/input/textinput/TextInput';
import Button from '../../../components/button/Button';
import EditPayer from '../addpayernew/editpayer/EditPayer';
import EditRecipient from '../addrecipientnew/editrecipient/EditRecipient';
import useTxNavigate from '../../../../libs/txnavigate/TxNavigateHook';
import Heading from '../../../components/heading/Heading';
import { HEADING } from '../../../components/heading/constants/constants';

export default function ImportDataGridView({
    isStateFilingApplicable = true,
    filingForCorrected = false,
    formSettings = {},
    formName = "NEC",
    formId = "47",
    taxYear = 2023,
}){
    const resettedPopupData = {
		FormId: null,
		MappingId: null,
		SelectedBox: null,
		BoxActionId: null,
		BoxActionName: null,
		CorrectAmount: null,
		ProcessDate: null,
		Invoice: null,
		RecipientName: null,
		PayerName: null,
		RecipientTin: null,
	}

    useGarbageCollector(componentKey);

    const { loadingState, reloadFormGridPageFieldsData, importGridRecords, gridViewPayerList, gridViewBoxSelected, fileOnlyForStateFlag, gridRecordsSelected, paginationState, errorPayerIds, reloadGridRecords, gridViewBoxOptionsList, isFinalFormSubmittedSuccessfully, saveImportFormSuccessData, editPayerData, payerUpdationSuccessful, clickedRecipientData, recipientEditSuccessfull, isSubmitBtnDisabled, submittedRecordsHasErrors } = useSelector(state => state[componentKey]);
    const { signedInUser } = useSelector((state) => state[authenticationComponentKey])
    
    const [selectedPayersString, setSelectedPayersString] = useState("");
    const [importFormsListingColumns, setImportFormsListingColumns] = useState([]);
    const [filterOptionsView, setFilterOptionsView] = useState(false);
    const [showEditBoxPopup, setShowEditBoxPopup] = useState(false);
    const [popupData, setPopupData] = useState(resettedPopupData);
    const [clickedPayerData, setClickedPayerData] = useState(null);
	const [isPayerEditOpen, setIsPayerEditOpen] = useState(false);
	const [isRecipientEditOpen, setIsRecipientEditOpen] = useState(false);
	const [clickedRecipientGridRowData, setClickedRecipientGridRowData] = useState(null);
		
    const dispatch = useDispatch();
    const navigate = useTxNavigate();

    useEffect(() => {
        dispatch(getFormGridPageFieldsData({ formId: formName, loadedPayerListFromView: gridViewPayerList, year: taxYear ?? null, showPayerDropdownFlag: formSettings?.showPayerDropdownFlag, signedInUser: signedInUser }));
        
        if(!formSettings?.showPayerDropdownFlag){
            handleGetImportGridRecords(paginationState);
        }
	}, []);

    useEffect(() => {
		if (isFinalFormSubmittedSuccessfully) {
			let extendedParameters = "";
			if(saveImportFormSuccessData?.IsCorrected === "G"){
				extendedParameters = extendedParameters + "&FormType=Corrected";
			}
			if(fileOnlyForStateFlag){
				extendedParameters = extendedParameters + "&FilingType=true";
			}
			navigate(`/${FORM_SECTION_ROUTES.FORMS}/${FORM_SECTION_ROUTES.LISTING}?TaxYear=${saveImportFormSuccessData?.TaxYear}&FormId=${saveImportFormSuccessData?.FormId}&PayerId=${saveImportFormSuccessData?.PayerId}${extendedParameters}`);
			dispatch(setIsFinalFormSubmittedSuccessfully(false));
			dispatch(setSaveImportFormSuccessData(null));
		}
	}, [isFinalFormSubmittedSuccessfully]);

    useEffect(() => {
		const FilterColumn = (
			<div style={styles.flagFilterColumnStyles}>
				<span>
					Flag
				</span>
				<span onClick={() => { setFilterOptionsView(!filterOptionsView) }}>
					<Icons familyName="vec" iconName={VEC_ICON_NAME.FILTER_ICON} transformScale={0.75} />
				</span>
				<div style={{ ...styles.flagFilterOptionsDiv, ...(filterOptionsView ? {} : styles.displayNone) }}>
					<div style={styles.flagFilterOptionsRow}>
						<RadioInput
							name="flagFilter"
							label={
								{ suffixLabel: <div style={styles.radioLabel}><div style={{ ...styles.flagCircle, ...styles.green }}></div><span>Filter records without errors</span></div> }
							}
							value={"true"}
							checked={paginationState.gridFilter == "true"}
							onChangeCb={(e) => handleFilterSelection("true")}
						/>
	
						<RadioInput
							name="flagFilter"
							label={
								{ suffixLabel: <div style={styles.radioLabel}><div style={{ ...styles.flagCircle, ...styles.red }}></div><span>Filter records with errors</span></div> }
							}
							value={"false"}
							checked={paginationState.gridFilter == "false"}
							onChangeCb={(e) => handleFilterSelection("false")}
						/>
					</div>
					<div style={styles.resetButton} onClick={() => handleFilterSelection("")}>
						Reset
					</div>
				</div>
			</div>
		);

		const mainColumns = [
			{
				field: "flag",
				header: FilterColumn,
				renderLogic: (row, idx) => <span style={{ ...styles.flagCircle, ...styles[row.recipientColor] }}></span>
			},
			{
				field: "recipientName",
				header: <Label>Recipient Name</Label>,
				renderLogic: (row, idx) => <span style={styles.errorIconContainerSpan}>
					<span style={styles.payerRecipientEditLinkStyle} onClick={() => handleEditRecipientClick(row)}>{(row?.Recipient && row?.Recipient !== "") ? row?.Recipient : "NONAME"}</span>
					{
					row?.PayeeErrors && <span>
						<TxTooltipWIcon
							id={`payee_error_${row?.MappingId}`}
							text={row?.PayeeErrors}
							iconName={VEC_ICON_NAME.ERROR_ICON}
							customTooltipstyles={styles.errorTooltip}
						/>
					</span>
				}
				</span>
				
			},
			{
				field: "recipientTIN",
				header: <Label>Recipient TIN</Label>,
				renderLogic: (row, idx) => <span>{row?.RecipientTIN}</span>
			},
			{
				field: "payerName",
				header: <Label>Payer Name</Label>,
				renderLogic: (row, idx) => <span>{(row?.PayerName && row?.PayerName !== "") ? row?.PayerName : "NONAME"}</span>
			},
			{
				field: "boxValue",
				header: <Label>Box Value</Label>,
				renderLogic: (row, idx) => <span style={styles.errorIconContainerSpan}><span>{row?.CorrectAmountValue}</span>
				{
					row?.OtherErrors && <span>
						<TxTooltipWIcon
							id={`box_error_${row?.MappingId}`}
							text={row?.OtherErrors}
							iconName={VEC_ICON_NAME.ERROR_ICON}
							customTooltipstyles={styles.errorTooltip}
						/>
					</span>
				}
				</span>
			},
			{
				field: "boxCategory",
				header: <Label>1099 Category</Label>,
				renderLogic: (row, idx) => <span style={styles.errorIconContainerSpan}><span>{row?.Boxnumber?.ActionName}</span></span>
			},
			{
				field: "action",
				header: <Label>Action</Label>,
				renderLogic: (row, idx) => RowActions(row, formSettings),
			},
		];
	
		const updatedMainColumns = formSettings?.gridColumns
		.filter(column => column.show)
		.map(column => {
			const matchingColumn = mainColumns.find(item => item?.field === column?.columnName);
			return matchingColumn ? { ...matchingColumn } : null;
		})
		.filter(Boolean);

		setImportFormsListingColumns(updatedMainColumns);

	}, [filterOptionsView]);

    useEffect(() => {
		if (reloadGridRecords) {
            handleGetImportGridRecords(paginationState);
			dispatch(setReloadGridRecords(false));
			handleEditBoxPopupCloseAction();
		}
	}, [reloadGridRecords]);

    useEffect(() => {
		const maxLength = 40;
		let payerNamesStr = (gridViewPayerList.filter(item => item.checked).map(item => item.Name).join(', '));
		payerNamesStr = payerNamesStr.length > maxLength ? payerNamesStr.substring(0, maxLength) + '...' : payerNamesStr;
		setSelectedPayersString(payerNamesStr);
	}, [gridViewPayerList]);

    useEffect(() => {
		if(payerUpdationSuccessful){
			handleEditPayerClose();
			dispatch(setReloadGridRecords(true));
			dispatch(setPayerUpdationSuccessful(false));
			dispatch(setEditPayerData(null));
			setClickedPayerData(null);
		}
		if(recipientEditSuccessfull){
			handleEditRecipientClose();
			dispatch(setReloadGridRecords(true));
			dispatch(setRecipientEditSuccessfull(false));
			dispatch(setClickedRecipientData(null));
		}
	}, [payerUpdationSuccessful, recipientEditSuccessfull]);

    const handleEditBoxPopupCloseAction = () => {
		setPopupData({ ...resettedPopupData });
		setShowEditBoxPopup(false);
	}

    const handleEditBoxSelectionChange = (selectedOption) => {
		setPopupData({
			...popupData,
			BoxActionId: selectedOption.value,
			BoxActionName: selectedOption.label,
			SelectedBox: selectedOption,
		});
	}

    const handleGetImportGridRecords = (requestData) => {
        dispatch(getFormGridRecords({
            formId: formName,
            requestData: requestData,
            errorPayerIds: errorPayerIds,
            year: taxYear ?? null,
        }));
    }
    
    const handlePayerSelectionSubmitBtnClk = () => {
        const {selectedPayerIdsArray, selectedPayerDisregardedEntitiesArray} = Forms.importGridPageSelectedPayerIds(gridViewPayerList, signedInUser?.MultiplePayerLocation);
		if (selectedPayerIdsArray.length > 0) {
			dispatch(setSelectedPayerList({ 
                formId: formName, 
                payerList: { Ids: selectedPayerIdsArray, DisregardedIds: selectedPayerDisregardedEntitiesArray}, 
                year: taxYear,
            }));
			dispatch(updatePaginationState({ page: 1, skip: 0 }));
		}
	}

    const RowActions = (row, formSettings) => (
		<div style={styles.actionButtonsContainer}>
			{
				formSettings?.showEditBoxButtonFlag && <IconLabel
					text="Edit"
					icon={VEC_ICON_NAME.EDIT_ICON}
					containerStyles={styles.actionButton}
					labelStyles={styles.actionButton}
					onClickCb={() => { handleBoxEditAction(row) }}
				/>
			}
			{
				formSettings?.showDeleteButtonFlag &&  <IconLabel
					text="Delete"
					icon={VEC_ICON_NAME.DELETE_ICON}
					containerStyles={styles.actionButton}
					labelStyles={styles.actionButton}
					onClickCb={() => {
						dispatch(deleteSingleRecord({
							formId: formName, 
							requestBody: {
								FormId: row.FormId,
								MappingId: row.MappingId,
							},
							year: taxYear,
						}))
					}}
				/>
			}
		</div>
	);

    const handleSelectAllClick = () =>{
		const isAllChecked = gridViewPayerList.every(item => item?.checked === true)

		const options = gridViewPayerList.map((opt) => {
			return {
				...opt,
				checked: !isAllChecked
			}
		})
		dispatch(setGridViewPayerList(options))	
	}

    const handleBoxSelectionChange = (selectedOption) => {

		if (gridRecordsSelected.length < 1) {
			dispatch(addNotifications({ heading: "Warning", message: "Please select atleast one record to proceed", variant: TOASTER_VARIANT.WARNING }))
			return false;
		}

		dispatch(setgridViewBoxSelected(selectedOption));
		const finalObject = importGridRecords.records.map(record => {
			const isSelected = gridRecordsSelected.some(selectedRecord =>
				selectedRecord.FormId === record.FormId && selectedRecord.MappingId === record.MappingId
			);

			return {
				key: isSelected.toString(),
				value: record.FormId,
				MappingId: record.MappingId
			};
		});
		dispatch(applyBoxToSelectedRecords({
			formId: formName,
			requestBody: {
				boxNoId: selectedOption.value,
				jsonPreferences: finalObject,
				SelectedPayer: [],
				SelectAllInAllPages: importGridRecords.isAllSelected,
				SetOnlyStateFiling: fileOnlyForStateFlag,
			},
			year: taxYear,
		}));
	}

    const handleSelectTotalRecordsChange = (isChecked) => {
		dispatch(setGridRecordsSelected(isChecked ? importGridRecords.records : []))
        dispatch(updateImportGridRecords({ isAllSelected: isChecked }))
	}

    const handleFilterSelection = (value) => {
		dispatch(updatePaginationState({ gridFilter: value }));
		dispatch(setReloadGridRecords(true));
		setFilterOptionsView(!filterOptionsView);
	}

    const handleBoxEditAction = (row) => {
		setPopupData({
			...popupData,
			FormId: row?.FormId,
			MappingId: row?.MappingId,
			BoxActionId: row?.Boxnumber?.ActionId,
			BoxActionName: row?.Boxnumber?.ActionName,
			SelectedBox: { label: row?.Boxnumber?.ActionName, value: row?.Boxnumber?.ActionId },
			CorrectAmount: row?.CorrectAmount,
			ProcessDate: null,
			Invoice: null,
			RecipientName: row?.Recipient,
			PayerName: row?.PayerName,
			RecipientTin: row?.RecipientTIN,
		});
		setShowEditBoxPopup(true);
	}

	const handlePayerClick = (rowData) => {
		let clickedPayer = gridViewPayerList.find(item => item?.MappingId == rowData?.FormId);
		clickedPayer = clickedPayer ? clickedPayer : gridViewPayerList.find(item => item?.IdNumber == rowData?.payerTin);

		if (clickedPayer) {
			setClickedPayerData(clickedPayer);
			dispatch(setEditPayerData(clickedPayer));
			setIsPayerEditOpen(true);
		}
	}

	const handleEditPayerClose = () => {
		dispatch(setEditPayerData(null));
		setClickedPayerData(null);
		setIsPayerEditOpen(false);
	}
	const handleSubmitEditedPayer = (payerData) => {
		dispatch(submitEditedPayer({payerData: payerData, oldPayerIdNumber: clickedPayerData?.IdNumber ?? "", oldPayerDisregardedEntity: clickedPayerData?.DisregardedEntity ?? "", oldPayerName: clickedPayerData?.LastName ?? "", mappingId: clickedPayerData?.MappingId, formId: formName, year: taxYear}));
	}

	const handleEditRecipientClick = (rowData) => {	
		setClickedRecipientGridRowData(rowData);
		dispatch(getRecipientDataForEdit({formId: formName, recipientName: rowData.Recipient, mappingId: rowData?.FormId , year: taxYear}));
	}

	useEffect(() => {
		if(clickedRecipientData){
			setIsRecipientEditOpen(true);
		}
	}, [clickedRecipientData]);

	useEffect(() => {
		if(reloadFormGridPageFieldsData){
			dispatch(getFormGridPageFieldsData({ formId: formName, loadedPayerListFromView: gridViewPayerList, year: taxYear ?? null, showPayerDropdownFlag: formSettings?.showPayerDropdownFlag, signedInUser: signedInUser }));
			dispatch(setReloadFormGridPageFieldsData(false));
		}
	}, [reloadFormGridPageFieldsData]);

	const handleEditRecipientClose = () => {
		dispatch(setClickedRecipientData(null));
		setClickedRecipientGridRowData(null);
		setIsRecipientEditOpen(false);
	}

	const handleSubmitEditedRecipient = (recipientData) => {
		dispatch(submitEditedRecipient({editedRecipientData: recipientData, oldRecipientName: clickedRecipientData?.LastName ?? "", mappingId: clickedRecipientGridRowData?.FormId, formId: formName, year: taxYear}));
	}

    const handleFinalBatchFormSubmission = () => {
        if(gridRecordsSelected.length < 1){
            dispatch(addNotifications({ heading: "Warning", message: "Please select atleast one record", variant: TOASTER_VARIANT.WARNING }))
            return false;
        }

        const finalObject = importGridRecords.records.map(record => {
            const isSelected = gridRecordsSelected.some(selectedRecord =>
                selectedRecord?.FormId === record?.FormId && selectedRecord?.MappingId === record?.MappingId
            );

            return {
                key: isSelected.toString(),
                value: record?.FormId,
                MappingId: record?.MappingId
            };
        });

        const selectedPayerIds = gridViewPayerList.filter((item) => item?.checked).map(item => item.Id);

        if(formSettings?.showPayerDropdownFlag && selectedPayerIds.length < 1){
            dispatch(addNotifications({ heading: "Warning", message: "No Payers have been selected", variant: TOASTER_VARIANT.WARNING }))
            return false;
        }

        dispatch(finalSubmitSelectedRecords({
            formId: formName,
            requestBody: {
                jsonPreferences: finalObject,
                SelectedPayer: selectedPayerIds,
                SelectAllInAllPages: importGridRecords.isAllSelected,
                SetOnlyStateFiling: fileOnlyForStateFlag,
            },
            year: taxYear,
        }));

        return false
    }

    const is1042SForm = formName === FORM_NAMES.FORM1042S ? true : false

    return <>
        <Loadable
            currentState={loadingState.state} 
            loadingStates={[IMPORT_DATA_LOADING_STATES.GRID_PAGE_LOADING]}
            messageMap={IMPORT_DATA_STATES_MESSAGE_MAP}
            isNewLoadable={true}
        >
			<div>
				<h3>Edit Data</h3>
				{
					formSettings?.showPayerDropdownFlag && <div style={styles.selectPayerRow}>
						<Label customStyles={styles.selectPayerLabel}>Select Payer:</Label>
						<div style={styles.payerSelectDropDown}>
							<Loadable
								currentState={loadingState.state} 
								loadingStates={[IMPORT_DATA_LOADING_STATES.GRID_PAGE_SELECTED_PAYERS_LOADING ]} 
								messageMap={IMPORT_DATA_STATES_MESSAGE_MAP}
								isNewLoadable={true}
							>
								<MultiSelectDropdownWLabel
									label={selectedPayersString || "Select Payer"}
									options={gridViewPayerList}
									onChangeCheckboxCb={(options) => dispatch(setGridViewPayerList(options))}
									buttonProps={[{
										type: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
										children: "Submit",
										onClickCb: () => handlePayerSelectionSubmitBtnClk(),
									}]}
									selectAllProps={{
										isSelectAll: true,
										label: "Select All",
										isChecked: gridViewPayerList.every(item => item.checked === true),
										onChangeCb: handleSelectAllClick,
										isDisabled: false,
									}}
								/>
							</Loadable>
						</div>
					</div>
				}
				<div style={styles.boxSelectRow}>
					{
						isStateFilingApplicable && !filingForCorrected ?
							<div style={styles.stateFilingCheckboxDiv}>
								<CheckboxWLabel
									checked={fileOnlyForStateFlag}
									label={"Only state submission, No Federal submission"}
									onChangeCb={() => dispatch(setFileOnlyForStateFlag(!fileOnlyForStateFlag))}
								/>
								<div>
									<TxTooltipWIcon
										id={"statesubmission-tooltip"}
										text={"If you check this option then the forms will be filed ONLY TO THE STATE/S and not to the Federal, even though the Federal amounts are entered."}
									/>
								</div>
							</div>
							: null
					}
					{
						formSettings?.showUpdateMultipleBoxesDropdownFlag && <div style={styles.boxSelectDropdownDiv}>
							<SelectDropdown
								label={"Select Box:"}
								placeHolder={"Select Box"}
								name={"boxSelectionDropdown"}
								value={gridViewBoxSelected ?? { label: "", value: "" }}
								onSelectCb={(name, selectedOption) => handleBoxSelectionChange(selectedOption)}
								options={gridViewBoxOptionsList}
							/>
						</div>
					}
				</div>
				<div style={styles.errorFlagLegendInfoContainer}>
					<div style={styles.errorFlagLegendInfoDiv}><span style={{ ...styles.flagCircle, ...styles.green }}></span><span>Good Data</span></div>
					<div style={styles.errorFlagLegendInfoDiv}><span style={{ ...styles.flagCircle, ...styles.red }}></span><span>Missing/Invalid Required Data</span></div>
				</div>
                <div style={styles.outerGridBox}>
					<div style={styles.outerGridBoxFirstRow}>
						<CheckboxWLabel
							checked={importGridRecords.isAllSelected}
							label={"Select All"}
							onChangeCb={() => handleSelectTotalRecordsChange(!importGridRecords.isAllSelected)}
						/>
                        <div style={styles.exportButtonsContainer}>
                            <Loadable
                                currentState={loadingState.state} 
                                loadingStates={[IMPORT_DATA_LOADING_STATES.GRID_PAGE_DOWNLOAD_ACTION_LOADING ]} 
                                messageMap={IMPORT_DATA_STATES_MESSAGE_MAP}
                                isNewLoadable={true}
                            >
                                <div onClick={() => dispatch(gridViewDownloadReports({ formId: formName, reportType: "RECORDS_REPORT", year: taxYear }))}>
										<Icons familyName='vec' iconName={VEC_ICON_NAME.DOWNLOAD_ICON} />
										<span style={styles.downloadTextStyle}>{"Export To Excel"}</span>
									</div>
                                    {
										importGridRecords.hasErrors ?
											<div onClick={() => dispatch(gridViewDownloadReports({ formId: formName, reportType: "ERROR_REPORT", year: taxYear }))}>
												<Icons familyName='vec' iconName={VEC_ICON_NAME.DOWNLOAD_ICON} />
												<span style={styles.downloadTextStyle}>{"Download Error List"}</span>
											</div>
											: null
									}
                            </Loadable>
                        </div>
					</div>
					<Loadable
						currentState={loadingState.state} 
						loadingStates={[IMPORT_DATA_LOADING_STATES.GRID_PAGE_TABLE_LOADING]} 
						messageMap={IMPORT_DATA_STATES_MESSAGE_MAP}
						isNewLoadable={true}
					>
						<RichGrid
							data={importGridRecords.records}
							columns={importFormsListingColumns}
							selectable={true}
							extractRowKey={(row) => row?.MappingId}
							onSelectionChangeCallBack={(selectedData) => dispatch(setGridRecordsSelected(selectedData))}
							onHeaderSelectionChangeCallBack={(selectedData) => dispatch(setGridRecordsSelected(selectedData))}
							selectedRows={gridRecordsSelected}
							groupBy={formSettings?.gridShowGroupByPayerRow ? "PayerName" : null}
							groupByRowProps={{
								onLabelClickCb: (dataRow) => { handlePayerClick(dataRow) },
								labelStyles: styles.payerRecipientEditLinkStyle,
							}}
							paginationProps={{
								skip: paginationState.skip,
								take: paginationState.pageSize,
								takeOptions: ROW_SELECTION_OPTIONS,
								onChangeTakeCb: (newTake) => {
									dispatch(updatePaginationState({ pageSize: newTake, page: 1, skip: 0 }));
									handleGetImportGridRecords({
                                        ...paginationState,
                                        pageSize: newTake,
                                        page: 1, 
                                        skip: 0,
                                    });
								},
								total: importGridRecords?.totalRecords,
								onChange: (take, skip) => {
									dispatch(updatePaginationState({ pageSize: take, skip: skip, page: Math.ceil((take + skip) / take) }))
                                    handleGetImportGridRecords({
                                        ...paginationState,
                                        skip: skip,
                                        page: Math.ceil((take + skip) / take),
                                        pageSize: take,
                                    });
								},
							}}
							selectTotalRecords={importGridRecords?.isAllSelected}
							setSelectTotalRecordsCb={(value) => dispatch(updateImportGridRecords({isAllSelected: value}))}
							showSelectAllRecordsWarningPopup={true}
						/>

						<div style={styles.amountsRow}>
							<div>
								<span style={styles.amountText}>Current Page Amount: </span>{General.formatCurrency(importGridRecords?.pageTotalAmount ?? 0)}
							</div>
							<div>
								<span style={styles.amountText}>Total Amount: </span>{General.formatCurrency(importGridRecords?.totalAmount ?? 0)}
							</div>
						</div>
						
					</Loadable>
				</div>
                <div style={styles.finalSubmitBtnContainer}>
                    <Button disabled={isSubmitBtnDisabled} type={BUTTON_TYPE.PRIMARY} onClickCb={handleFinalBatchFormSubmission}>
                        Submit
                    </Button>
                </div>
			</div>
			{
				popupData?.FormId ?
					<Popup title="Edit Box" isPopupOpen={showEditBoxPopup} onCloseCb={handleEditBoxPopupCloseAction} showClose={true} childrenStyles={styles.popupBodyStyles}>
						<div style={styles.editContainer}>
							<div style={styles.payerRecipientRow}>
								<div style={styles.nameContainer}>
									<div style={styles.iconDiv}>
										<Icons familyName="vec" iconName={VEC_ICON_NAME.CREATE_FORM_SUCCESS_PAYER_ICON} />
									</div>
									<div style={styles.nameDiv}>
										<div style={styles.lightText}>
											Payer
										</div>
										<div style={styles.nameText}>
											{popupData.PayerName}
										</div>
									</div>
								</div>
								<div style={styles.nameContainer}>
									<div style={styles.iconDiv}>
										<Icons familyName="vec" iconName={VEC_ICON_NAME.CREATE_FORM_SUCCESS_RECIPIENT_ICON} />
									</div>
									<div style={styles.nameDiv}>
										<div style={styles.lightText}>
											Recipient
										</div>
										<div style={styles.nameText}>
											{popupData.RecipientName}<br />
											{popupData.RecipientTin}
										</div>
									</div>
								</div>
							</div>
							<div style={styles.editFieldsContainer}>
								<Loadable
									currentState={loadingState.state} 
									loadingStates={[IMPORT_DATA_LOADING_STATES.GRID_PAGE_EDIT_BOX_ACTION_LOADING ]} 
									messageMap={IMPORT_DATA_STATES_MESSAGE_MAP}
									isNewLoadable={true}
								>
									<div style={styles.popupBoxValueField}>
										<Label weight={700}>1099 Category:</Label>
										<SelectDropdown
											placeHolder={"Select Box"}
											name={`boxEditDropdown_${popupData.MappingId}`}
											value={popupData.SelectedBox ?? { label: "", value: "" }}
											onSelectCb={(name, selectedOption) => handleEditBoxSelectionChange(selectedOption)}
											options={gridViewBoxOptionsList}
										/>
									</div>
									<div style={styles.popupBoxValueField}>
										<Label weight={700}>
											Box Value:
										</Label>
										<TextInput
											type={'text'}
											placeHolder={'Box Value'}
											name={'CorrectAmount'}
											value={popupData.CorrectAmount}
											onChangeCb={(e) => setPopupData({
												...popupData,
												CorrectAmount: e.target.value,
											})}
										/>
									</div>
									<Button type={BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER} onClickCb={() => dispatch(updateSingleBox({ formId: formName, requestBody: popupData, year: taxYear }))}>Submit</Button>
								</Loadable>
							</div>
						</div>
					</Popup>
					: null
			}
            
            {
				importGridRecords?.hasRecipientWithoutTIN && <ConfirmationPopup
					title={"Please Note"}
					bodyText={"Some of your Recipients have missing TINs. You may add a TIN by clicking on the Recipient name where the Recipient TIN is blank, which you can see in the fifth column in this grid. You may also proceed to file the forms with no TIN provided. After this page you will still have an opportunity to supply a TIN by editing the form on the next page."}
					iconName={VEC_ICON_NAME.WARNING_ICON}
					isOpen={importGridRecords?.hasRecipientWithoutTIN}
					confirmationButtonProps={{
						onConfirmationCb: () => {
							dispatch(proceedWithoutUpdatingTin({
								formId: formName,
								year: taxYear,
							}))
						},
						confirmationButtonText: "Proceed without TIN",
						confirmationButtonStyles: {},
						confirmationButtonType: BUTTON_TYPE.PRIMARY,
					}}
					cancelButtonProps={{
						onCancelCb: () => dispatch(updateImportGridRecords({
							hasRecipientWithoutTIN: false
						})),
						cancelButtonText: "Edit TIN before Submission",
						cancelButtonStyles: {},
						cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
					}}
					showClose={false}
				/>
			}
            {
				(editPayerData) && <EditPayer fromNecGrid={true} payerData={editPayerData} isPopup={true} isPopupOpen={isPayerEditOpen} onPopupCloseCb={handleEditPayerClose} submitFormCb={(editPayerData) => handleSubmitEditedPayer(editPayerData)} is1042SForm={is1042SForm} loaderProps={{currentState:loadingState.state, loadingStates:[IMPORT_DATA_LOADING_STATES.SUBMIT_EDITED_PAYER_LOADING], messageMap: IMPORT_DATA_STATES_MESSAGE_MAP}}/>
			}
			{clickedRecipientData && <EditRecipient fromNecGrid={true} recipientData={clickedRecipientData} isPopup={true} isPopupOpen={isRecipientEditOpen} onPopupCloseCb={handleEditRecipientClose} submitFormCb={(formData) => handleSubmitEditedRecipient(formData)} is1042SForm={is1042SForm} loaderProps={{currentState:loadingState.state, loadingStates:[IMPORT_DATA_LOADING_STATES.SUBMIT_EDITED_RECIPIENT_LOADING], messageMap: IMPORT_DATA_STATES_MESSAGE_MAP}} fromFormModule={true} />}
			{
				importGridRecords?.hasRecipientWithoutTIN && <ConfirmationPopup
					title={"Please Note"}
					bodyText={"Some of your Recipients have missing TINs. You may add a TIN by clicking on the Recipient name where the Recipient TIN is blank, which you can see in the fifth column in this grid. You may also proceed to file the forms with no TIN provided. After this page you will still have an opportunity to supply a TIN by editing the form on the next page."}
					iconName={VEC_ICON_NAME.WARNING_ICON}
					isOpen={importGridRecords?.hasRecipientWithoutTIN}
					confirmationButtonProps={{
						onConfirmationCb: () => {
							dispatch(proceedWithoutUpdatingTin({
								formId: formName,
								year: taxYear,
							}))
						},
						confirmationButtonText: "Proceed without TIN",
						confirmationButtonStyles: {},
						confirmationButtonType: BUTTON_TYPE.PRIMARY,
					}}
					cancelButtonProps={{
						onCancelCb: () => dispatch(updateImportGridRecords({
							hasRecipientWithoutTIN: false
						})),
						cancelButtonText: "Edit TIN before Submission",
						cancelButtonStyles: {},
						cancelButtonType: BUTTON_TYPE.PRIMARY_LIGHT_WITH_BORDER,
					}}
					showClose={false}
				/>
			}
            {submittedRecordsHasErrors ?
                <Popup title={""} onCloseCb={() => dispatch(setSubmittedRecordsHasErrors(false))} isPopupOpen={submittedRecordsHasErrors} childrenStyles={styles.popupChildrenStyle}>
                    <div style={styles.reportErrorsDownloadPopupInnerDiv}>
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.WARNING_ICON} />
						<div style={styles.errorReportTextContainer}>
							<Heading type={HEADING.H2}>Your import has errors.</Heading>
							<span style={styles.errorNote}>Note: This report will contain error details of all records of your import</span>
						</div>
                    </div>
                    <Button type={BUTTON_TYPE.LIGHT_WITH_NO_BORDER} onClickCb={() => {
                        dispatch(gridViewDownloadReports({ formId: formName, reportType: "ERROR_REPORT", year: taxYear }))

                    }}>Download error Report</Button>
                </Popup>
                : null}    
		</Loadable>
    </>
}